
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Progress } from '@/components/ui/progress';

interface DashboardProgressProps {
  hasBalanceSheetData: boolean;
  hasFinancialAssumptions: boolean;
  canRunModel: boolean;
}

export function DashboardProgress({ 
  hasBalanceSheetData,
  hasFinancialAssumptions,
  canRunModel
}: DashboardProgressProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle>Setup Progress</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <div className="flex justify-between text-sm mb-1">
              <span>Balance Sheet Setup</span>
              <span>{hasBalanceSheetData ? '100%' : '0%'}</span>
            </div>
            <Progress value={hasBalanceSheetData ? 100 : 0} />
          </div>
          <div>
            <div className="flex justify-between text-sm mb-1">
              <span>Financial Assumptions</span>
              <span>{hasFinancialAssumptions ? '100%' : '0%'}</span>
            </div>
            <Progress value={hasFinancialAssumptions ? 100 : 0} />
          </div>
          <div>
            <div className="flex justify-between text-sm mb-1">
              <span>AI Model Readiness</span>
              <span>{canRunModel ? '100%' : '0%'}</span>
            </div>
            <Progress value={canRunModel ? 100 : 0} />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>System Health</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-sm">Data Integration</span>
            <Badge variant="default">Healthy</Badge>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm">AI Analytics</span>
            <Badge variant={canRunModel ? "default" : "secondary"}>
              {canRunModel ? "Ready" : "Needs Data"}
            </Badge>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm">Backup Status</span>
            <Badge variant="secondary">Up to Date</Badge>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
